import { StyleSheet } from '@react-pdf/renderer';

const VERTICAL_CELL_PADDING = 3;

export const tableStyles = StyleSheet.create({
  table: {
    marginTop: 4,
    marginBottom: 16,
  },
  tr: {
    flexDirection: 'row',
  },
  cell: {
    paddingVertical: VERTICAL_CELL_PADDING,
    paddingHorizontal: 3,
  },
});
